var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCertificateMedal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 21,
    viewBox: "0 0 20 21",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(3 3.593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.2500002 13.907v4.5l-2.25000003-1.125-2.25 1.125v-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.22000017 11.244.532.7.115.865c.0639251.479691.441309.857075.921.921l.867.116.694.531h.00000003c.38413.292038.91587.292038 1.3 0l.7-.531.866-.116h.0000001c.479919-.063836.857643-.44115.922-.921l.116-.867s.268-.351.531-.694c.292038-.38413.292038-.91587 0-1.30000004l-.531-.7-.116-.865v-.00000011c-.0634041-.479761-.440378-.857554-.92-.922l-.868-.115-.70000004-.53.00000004.00000002c-.383782-.293067-.916218-.293067-1.3-.00000005l-.7.53-.866.115h-.00000002c-.479853.0635979-.857402.441147-.921.921l-.116.867-.531.694.00000005-.00000006c-.290387.38568104-.288343.91756304.00499996 1.30100004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 15.4070003h2c1.1045701 0 2-.8954303 2-2.0000003v-11.407c0-1.10457-.8954309-2-2-2h-14c-1.10457 0-2 .895431-2 2v11.407.0000003c0 1.10457.895431 2 2 2h2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.5 3.407h9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateMedal);
export default __webpack_public_path__ + "static/media/certificate-medal.c3d69cf3dc1ccd539cedc3d0108d0db0.svg";
export { ForwardRef as ReactComponent };